"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lunaIcon = _interopRequireDefault(require("../luna-icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaButton = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([{
    condition: function condition(_ref) {
      var _ref$other = _ref.other;
      _ref$other = _ref$other === void 0 ? {} : _ref$other;
      var form = _ref$other.form;
      return form;
    },
    message: 'The form attribute has been promoted to a first-class attribute at LunaButton#form. LunaButton#other.form will be ignored in v4, please use LunaButton#form instead',
    breakingVersion: 4
  }], props);
  var children = props.children,
      className = props.className,
      component = props.component,
      disabled = props.disabled,
      form = props.form,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      size = props.size,
      type = props.type,
      icon = props.icon,
      iconPosition = props.iconPosition,
      htmlType = props.htmlType,
      other = props.other;

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        types = _config.classes.types,
        sizes = _config.classes.sizes,
        disabledClass = _config.classes.disabled,
        iconPositions = _config.classes.iconPositions;
    return (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, disabledClass, disabled), _defineProperty(_classnames, types.primary, !type || type === _config.ButtonTypes.primary), _defineProperty(_classnames, types.secondary, type === _config.ButtonTypes.secondary), _defineProperty(_classnames, types.tertiary, type === _config.ButtonTypes.tertiary), _defineProperty(_classnames, sizes.small, size === _config.ButtonSizes.small), _defineProperty(_classnames, sizes.full, size === _config.ButtonSizes.full), _defineProperty(_classnames, iconPositions[_config.ButtonIconPositions.iconOnly], (iconPosition === _config.ButtonIconPositions.iconOnly || icon) && !children), _defineProperty(_classnames, iconPositions[_config.ButtonIconPositions.iconLeft], (iconPosition === _config.ButtonIconPositions.iconLeft || icon) && children), _classnames), className);
  };

  var getComponentType = function getComponentType() {
    if (component === 'button' && other.href) {
      return 'a';
    }

    return component;
  };

  var getButtonProps = function getButtonProps() {
    var buttonProps = {};

    if (getComponentType() === 'button') {
      buttonProps.type = htmlType || 'button';
      buttonProps.disabled = disabled;
      buttonProps.form = form || other.form;
    } else {
      buttonProps.role = 'button';
      buttonProps['aria-disabled'] = disabled;
    }

    return buttonProps;
  };

  var getIconComponent = function getIconComponent() {
    if (icon) {
      return _react["default"].createElement(_lunaIcon["default"], {
        className: "luna-button--icon",
        glyph: icon
      });
    } else {
      return null;
    }
  };

  var ComponentTag = getComponentType();
  return _react["default"].createElement(ComponentTag, _extends({}, other, {
    className: getClassList(),
    disabled: disabled,
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref
  }, getButtonProps()), getIconComponent(), children);
});

LunaButton.propTypes = {
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  form: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  icon: _propTypes["default"].string,
  iconPosition: _propTypes["default"].oneOf(Object.values(_config.ButtonIconPositions)),
  size: _propTypes["default"].oneOf(Object.values(_config.ButtonSizes)),
  type: _propTypes["default"].oneOf(Object.values(_config.ButtonTypes)),
  htmlType: _propTypes["default"].string
};
LunaButton.defaultProps = {
  component: 'button',
  other: {}
};
LunaButton.displayName = 'LunaButton';
var _default = LunaButton;
exports["default"] = _default;
